/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import reactUpdate from 'immutability-helper';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import ManageSelectorsModalClass from 'notebook/plain-tables/selectors/ManageSelectorsModal';
// @ts-expect-error
import EditorActions from 'notebook/protocols/actions/EditorActions';
// @ts-expect-error
import ProtocolViewComponent from 'notebook/protocols/ProtocolViewComponent';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import * as vo from 'settings/visibility-options/VisibilityOptions';
import * as ModalContainer from 'ui-library/ModalContainer';

interface ProtocolTabViewComponentProps {
  protocol: any;
  updateProtocol: (newProtocol: any) => void;
  revertProtocol: (protocol: any, selectionData: any) => void;
  savedVersion: any;
  openVersion: any;
  displayOptions: any;
  saving: any;
  banner?: string;
  fileId: string;
  onSaving?: () => void;
  onRetrying?: () => void;
  onSaved?: () => void;
  locked: boolean;
  printHandler?: () => void;
  printOptions?: Array<any>;
  historyManager: any;
  spellCheck: boolean;
  printLayout: boolean;
  showPrintMargins: boolean;
}

type State = any;

class ProtocolTabViewComponent extends React.Component<ProtocolTabViewComponentProps, State> {
  override state: State = {showManageSelectorsModal: false, initialSelectorId: null};

  constructor(props: ProtocolTabViewComponentProps) {
    super(props);
    this.state = {showManageSelectorsModal: false, initialSelectorId: null, ...this.getMoreFormats(props)};
  }

  override UNSAFE_componentWillReceiveProps(nextProps: ProtocolTabViewComponentProps): void {
    if (this.props.locked !== nextProps.locked) {
      this.setMoreFormats(nextProps);
    }
  }

  override componentDidUpdate(prevProps: ProtocolTabViewComponentProps, prevState: State): void {
    const manageSelectorsModalProps = {
      initialSelectorId: this.state.initialSelectorId,
      locked: this.props.locked,
      parentType: 'Protocol',
      selectorsLink: {
        value: this.props.protocol.selectors,
        requestChange: this.updateSelectors,
        selectorUsageCounts: ManageSelectorsModalClass.countSelectors(this.props.protocol.steps),
      },
      onRequestClose: this.closeManageSelectorsModal,
    };
    this.toggleManageSelectorsModal(prevState, this.state, manageSelectorsModalProps);
  }

  toggleManageSelectorsModal = (prevState: any, curState: any, manageSelectorsModalProps: any): void => {
    if (curState.showManageSelectorsModal) {
      ModalContainer.open(
        ManageSelectorsModalClass,
        <ManageSelectorsModalClass {...manageSelectorsModalProps} />
      );
    } else if (prevState.showManageSelectorsModal && !curState.showManageSelectorsModal) {
      this.closeManageSelectorsModal();
    }
  };

  openManageSelectorsModal = (initialSelectorId: any): void => {
    this.setState({showManageSelectorsModal: true, initialSelectorId});
  };

  closeManageSelectorsModal = (): void => {
    this.setState({showManageSelectorsModal: false, initialSelectorId: null});
    ModalContainer.close(ManageSelectorsModalClass);
  };

  getMoreFormats = (
    props: ProtocolTabViewComponentProps
  ): {
    moreFormats: Array<{
      format: string;
      moreKey: string;
      onClick: (initialSelectorId: any) => void;
      tooltip: Array<string>;
    }>;
  } => ({
    moreFormats: [
      {
        format: 'selector',
        moreKey: 'default',
        tooltip: [props.locked ? 'View Selectors' : 'Manage Selectors'],
        onClick: this.openManageSelectorsModal,
      },
    ],
  });

  setMoreFormats = (props: ProtocolTabViewComponentProps): void => {
    this.setState(this.getMoreFormats(props));
  };

  updateSelectors = (newSelectors: any): void => {
    const newProtocol = reactUpdate(this.props.protocol, {$merge: {selectors: newSelectors}});
    this.props.updateProtocol(newProtocol);
  };

  override render(): JSX.Element {
    return (
      <ProtocolViewComponent
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, this.props, {
          openManageSelectorsModal: this.openManageSelectorsModal,
          moreFormats: this.state.moreFormats,
        })}
      />
    );
  }
}

/* eslint-disable @typescript-eslint/unbound-method */
class TabView extends Backbone.View<any> {
  declare printOptions: any;

  static initClass(): void {
    this.prototype.className = 'protocol-tab buffer-tab buffer-tab--no-padding';
    this.prototype.printOptions = ['protocol'];
  }

  override initialize(): void {
    // Bind methods to `this` so they can be threaded into React components
    this.updateProtocol = this.updateProtocol.bind(this);
    this.revertProtocol = this.revertProtocol.bind(this);
    this.printHandler = this.printHandler.bind(this);

    this.listenTo(this.model.get('protocol'), 'change', this.rerender);
    this.listenTo(this.model.get('displayOptions'), 'redraw', this.rerender);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
  override render() {
    this.$el.html('<div class="protocol-mount"></div>');
    this.rerender();
    return this;
  }

  updateProtocol(data: any): void {
    EditorActions.update(this.model.get('protocol').proxied().id, {$merge: data});
  }

  revertProtocol(protocol: any, selectionData: any): void {
    EditorActions.revert(this.model.get('protocol').proxied().id, protocol, selectionData);
  }

  printHandler(): void {
    EditorActions.print(this.model.get('protocol').proxied().id);
  }

  rerender(): void {
    const protocolProxy = this.model.get('protocol');

    const printLayoutOption = this.model.get('displayOptions').getOption(vo.ELN_PRINT_LAYOUT.name);
    const protocolView = (
      <ProtocolTabViewComponent
        banner={protocolProxy.getBannerText()}
        fileId={this.model.get('protocol').proxied().id}
        protocol={protocolProxy.proxied()}
        locked={!protocolProxy.allowEdits()}
        saving={protocolProxy.get('saving')}
        savedVersion={protocolProxy.get('savedVersion')}
        openVersion={protocolProxy.get('openVersion')}
        historyManager={protocolProxy.get('historyManager')}
        updateProtocol={this.updateProtocol}
        revertProtocol={this.revertProtocol}
        printHandler={this.printHandler}
        printOptions={this.printOptions}
        displayOptions={this.model.get('displayOptions')}
        spellCheck={this.model.get('displayOptions').getOption(vo.ELN_SPELL_CHECK.name).get('visible')}
        printLayout={printLayoutOption.get('visible')}
        showPrintMargins={printLayoutOption.isSettingChecked(vo.ELN_SHOW_PRINT_MARGINS.name)}
      />
    );
    renderToDOM(protocolView, this.$('.protocol-mount')[0]);

    // Keep scroll top value between rerenders. If scrollTop is undefined,
    // this does nothing.
    const scroller = this.$('.protocolEditor-pageContainer');
    scroller.scroll(() => this.model.set('scrollTop', scroller.scrollTop()));
  }

  afterAttach(): void {
    this.$('.protocolEditor-pageContainer').scrollTop(this.model.get('scrollTop'));
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
  override remove() {
    ReactDOM.unmountComponentAtNode(this.$('.protocol-mount')[0]);
    return super.remove();
  }
}
/* eslint-enable @typescript-eslint/unbound-method */
TabView.initClass();

export const OptionsView = null;
export {TabView};
